import { Box } from '@hopskipdrive/react-components';
import { Delete, Edit } from '@mui/icons-material';
import { Button } from '@rideiq/shared/components/Button';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

const MOBILE = '@media (max-width: 599px)';

export const Container = styled(Box)`
  border-radius: 12px;
  border: 1px solid ${colorPalette.neutralVariant90};
  padding: 1.5rem;
`;

export const ProtocolContainer = styled(Box)`
  display: flex;
  gap: 2rem;
  margin-bottom: 1.5rem;

  & > div:first-child {
    display: flex;
    flex-direction: row;
    flex: 2;
    gap: 2rem;
  }

  & > div:last-child {
    flex: 3;
  }

  .MuiAutocomplete-root {
    width: 200px;
  }

  label {
    margin-top: 10px;
    width: 125px;
  }

  ${MOBILE} {
    flex-direction: column;

    & > div:first-child {
      flex-direction: column;
      gap: 4px;
    }

    .MuiAutocomplete-root {
      width: 100%;
    }

    label {
      width: auto;
      margin-top: 0;
    }
  }
`;

export const ProtocolEducationContainer = styled(Box)`
  background: ${colorTokens.background.light};
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  white-space: pre-line;
`;

export const AuthorizedContactGroupContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ContactGroupViewContainer = styled(Box)`
  border-radius: 0.75rem;
  border: 1px solid ${colorPalette.neutralVariant90};
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContactGroupFormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${colorTokens.info.main};
  padding: 1.5rem;
  gap: 1.5rem;
`;

export const ContactGroupFlexRow = styled(Box)`
  display: flex;
  gap: 1rem;
  align-items: center;
  label: {
    flex: 1;
  }
  .MuiAutocomplete-root {
    flex: 1;
  }
  .MuiFormControl-root {
    flex: 1;
  }

  ${MOBILE} {
    flex-direction: column;
    align-items: flex-start;

    .MuiAutocomplete-root,
    .MuiFormControl-root {
      width: 100%;
    }
  }
`;

export const CreateNewGroupButton = styled(Button)`
  justify-content: flex-start;
  width: 150px;
`;

export const DeleteIcon = styled(Delete)`
  cursor: pointer;
  color: ${colorTokens.error.main};
`;

export const EditIcon = styled(Edit)`
  cursor: pointer;
  color: ${colorTokens.action.active};
`;

export const CreateNewGroupButtonV2 = styled(Button)`
  justify-content: flex-start;
  width: 220px;
`;
